import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "flex flex-col space-y-2"
}

import { computed } from "vue";
import { Indexable } from "@types";


export default /*#__PURE__*/_defineComponent({
  __name: 'FooterGridItem',
  props: ["title", "routes", "size"],
  setup(__props) {

const props = __props



const sizes: Indexable<Indexable<string>> = {
    title: { md: "font-semibold", lg: "title-2 !mb-0" },
    cols: { md: "col-span-1", lg: "col-span-2" },
};

const classes = computed(() => {
    const size = props.size || "md";
    const title = sizes.title[size];
    const wrapper = [
        sizes.cols[size],
        "flex flex-col items-start justify-between space-y-6 lg:py-24 p-8",
    ];

    return {
        title,
        wrapper,
    };
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_unref(classes).wrapper)
  }, [
    (__props.title)
      ? (_openBlock(), _createElementBlock("h3", {
          key: 0,
          class: _normalizeClass(_unref(classes).title)
        }, _toDisplayString(__props.title), 3))
      : _createCommentVNode("", true),
    _renderSlot(_ctx.$slots, "default"),
    (__props.routes)
      ? (_openBlock(), _createElementBlock("ul", _hoisted_1, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.routes, (to, name) => {
            return (_openBlock(), _createElementBlock("li", { key: name }, [
              _createVNode(_component_router_link, {
                to: to,
                class: "link text-sm"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(name), 1)
                ]),
                _: 2
              }, 1032, ["to"])
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})